export default __webpack_public_path__ + "static/media/goopter-ecommerce-direct-payment-transfers.323fdd7d.jpg";